import React, {useState} from "react";
import axiosInstance from "../../utils/axiosInstance";
import {useNavigate} from "react-router-dom";
import {IoArrowBackSharp} from "react-icons/io5";

const AddAdditionalPrice = () => {
    const [formData, setFormData] = useState({
        column: "",
        value: "",
        credits: "",
        rule: "",
    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await axiosInstance.post("/additional-prices", {
                column: formData.column,
                value: formData.value,
                credits: parseFloat(formData.credits),
                rule: formData.rule,
            });

            setLoading(false);
            navigate("/admin/additional-prices");
        } catch (err) {
            setError("Failed to add additional price. Please try again.");
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
                {/* Go Back Button */}
                <button
                    onClick={() => window.history.back()}
                    className="rounded-full hover:bg-gray-200 transition-all mr-2"
                >
                    <IoArrowBackSharp size={24}/>
                </button>
                Add Additional Price
            </h3>

            <form
                onSubmit={handleSubmit}
                className="bg-white p-6 rounded-lg shadow-md"
            >
                <div className="mb-4">
                    <label
                        htmlFor="column"
                        className="block text-gray-700 font-semibold mb-2"
                    >
                        Column
                    </label>
                    <select
                        id="column"
                        name="column"
                        value={formData.column}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    >
                        <option value="">Select column</option>
                        <option value="ecu">Ecu</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="value"
                        className="block text-gray-700 font-semibold mb-2"
                    >
                        Value
                    </label>
                    <input
                        type="text"
                        id="value"
                        name="value"
                        value={formData.value}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="e.g. edc16p"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="credits"
                        className="block text-gray-700 font-semibold mb-2"
                    >
                        Additional Credits
                    </label>
                    <input
                        type="number"
                        id="credits"
                        name="credits"
                        value={formData.credits}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        min="0"
                        step="0.01"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="rule"
                        className="block text-gray-700 font-semibold mb-2"
                    >
                        Rule
                    </label>
                    <select
                        id="rule"
                        name="rule"
                        value={formData.rule}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    >
                        <option value="">Select rule</option>
                        <option value="CONTAINS">CONTAINS</option>
                        <option value="STARTS_WITH">STARTS WITH</option>
                        <option value="EXACT_MATCH">EXACT MATCH</option>
                    </select>
                </div>

                {error && <p className="text-red-500 mb-4">{error}</p>}

                {/* Submit */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className={`px-4 py-2 text-white rounded-md ${
                            loading
                                ? "bg-gray-400"
                                : "bg-green-500 hover:bg-green-600"
                        }`}
                        disabled={loading}
                    >
                        {loading ? "Adding..." : "Add Additional Price"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddAdditionalPrice;